var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-loop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-loop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-loop"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-loop",
    transform: "translate(3.000000, 4.000000)",
    fill: "#313131",
    fillRule: "nonzero",
    stroke: "#313131",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6597988,6.01873416 C20.4398658,7.39207568 21.2199329,8.7627913 22,10.1361328 C21.4492094,10.1361328 20.8984188,10.1361328 20.3476282,10.1361328 C20.3766172,11.0105549 20.3291806,12.8276721 19.3988979,14.7944652 C19.1959751,15.2224856 18.2472448,17.1472645 16.1389554,18.5836274 C13.258505,20.5477946 10.3200767,20.1670403 9.72712027,20.0777599 C6.87302348,19.6444878 5.06252995,17.937658 4.44849066,17.304818 C4.75946334,16.9713297 5.07043603,16.6378414 5.38140872,16.3043531 C5.91638716,16.866294 7.46334451,18.3341677 9.87997125,18.6991666 C12.8974605,19.1560718 15.1322472,17.5752849 15.756828,17.0921207 C17.3169621,15.8868363 18.0311452,14.4163368 18.2050791,14.0408342 C18.969334,12.391774 19.0220412,10.8818861 19.0009583,10.1361328 C18.4501677,10.1361328 17.8993771,10.1361328 17.3485865,10.1361328 C18.1181121,8.7627913 18.8876378,7.39207568 19.6597988,6.01873416 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34020125,14.1484958 C1.56013416,12.7751543 0.780067082,11.4044387 0,10.0310971 C0.550790609,10.0310971 1.10158122,10.0310971 1.65237183,10.0310971 C1.62338285,9.1566751 1.67081936,7.33955784 2.60110206,5.37276473 C2.80402492,4.94474433 3.75275515,3.01996549 5.86104456,1.58360257 C8.74149497,-0.383190543 11.6799233,0.000189689762 12.2728797,0.0894700179 C15.1269765,0.522742198 16.9374701,2.229572 17.5515093,2.86241197 C17.2405367,3.19590026 16.929564,3.52938854 16.6185913,3.86287683 C16.0836128,3.30093594 14.5366555,1.83306231 12.1200287,1.46806332 C9.10253953,1.01115811 6.86775276,2.5919451 6.24317202,3.07510922 C4.68303785,4.28039365 3.96885482,5.75089317 3.79492094,6.12639573 C3.03066603,7.77545591 2.97795879,9.28534381 2.99904169,10.0310971 C3.5498323,10.0310971 4.1006229,10.0310971 4.65141351,10.0310971 C3.88188788,11.4044387 3.10972688,12.7751543 2.34020125,14.1484958 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoop);
export default __webpack_public_path__ + "static/media/icon-loop.6f4cf7ff093a00df855559b5e55e4695.svg";
export { ForwardRef as ReactComponent };